const apps = [
  { name: "微信", icon: "💬", url: "weixin://" },
  { name: "知乎", icon: "📝", url: "https://zhihu.com" },
  { name: "B站", icon: "📺", url: "https://bilibili.com" },
  { name: "抖音", icon: "🎵", url: "https://douyin.com" },
  { name: "树洞", icon: "🌲", url: "/treehole" },
];

export default apps;